import { ShieldCheck, BarChart3, Users2, Wand2, MessageSquare, Trophy, Rocket } from "lucide-react";

const reasons = [
  { icon: Trophy, title: "6+ Years of Practical Experience", desc: "Hands-on marketing across dozens of industries and business sizes." },
  { icon: BarChart3, title: "Strong SEO & Paid Ads Background", desc: "Deep expertise across both organic and paid growth channels." },
  { icon: Rocket, title: "Proven Growth Numbers", desc: "Track record of scaling traffic, keywords, DA and lead contribution." },
  { icon: Users2, title: "Managed 25+ SEO Professionals", desc: "Leadership experience running large SEO and content operations." },
  { icon: ShieldCheck, title: "Data-Driven Approach", desc: "Every decision backed by analytics, testing and clear KPIs." },
  { icon: Wand2, title: "AI & Automation Knowledge", desc: "Modern workflows using ChatGPT, GA4, GSC, SEMrush and more." },
  { icon: MessageSquare, title: "Transparent Communication", desc: "Clear reports, weekly updates and honest recommendations." },
];

export default function WhyChoose() {
  return (
    <section id="why" className="bg-slate-50 border-y border-slate-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-28">
        <div className="max-w-3xl reveal">
          <div className="text-xs font-bold uppercase tracking-widest text-blue-600">Why Choose Us</div>
          <h2 className="mt-3 font-display text-3xl md:text-5xl font-bold text-slate-900 tracking-tight">
            A senior operator, not a generic agency.
          </h2>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reasons.map((r, i) => (
            <div
              key={r.title}
              data-testid={`why-item-${i}`}
              className="reveal bg-white border border-slate-200 rounded-3xl p-7 hover:border-blue-200 hover:shadow-lg transition-all"
            >
              <div className="w-12 h-12 rounded-2xl bg-blue-50 text-blue-600 grid place-items-center">
                <r.icon className="w-6 h-6" />
              </div>
              <h3 className="mt-5 font-display font-bold text-slate-900 text-lg">{r.title}</h3>
              <p className="mt-2 text-sm text-slate-600 leading-relaxed">{r.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
